import { Button, FormControl, InputLabel, MenuItem, Select, TextField } from "@material-ui/core";
import React, { useState } from "react";
import DeleteIcon from "@material-ui/icons/Delete";
import adminService from "../../Services/adminService";
import Swal from "sweetalert2";
import AddBoxIcon from "@material-ui/icons/AddBox";
import AdminCoursesPopup from "../../NestedComponents/widgets/adminCoursesPopup";

const AdminCourses = (props) => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [courseInfo, setCourseInfo] = useState({});

  return (
    <div className="flex flex-direction-column items-center height500">
      <h3 className="mt-30 mb-50">קורסים</h3>
      <AdminCoursesPopup
        isPopupOpen={isPopupOpen}
        handleClosePopup={handleClosePopup}
        handleAction={handleUpdate}
        popupTitle="ערוך את פרטי הקורס"
        buttonText="עדכון"
      >
        <TextField
          autoFocus
          margin="dense"
          label="כותרת הקורס"
          fullWidth
          variant="standard"
          value={courseInfo.title || ""}
          onChange={(e) => onChange("title", e.target.value)}
        />
        <FormControl variant="standard" fullWidth>
          <InputLabel>האם פעיל</InputLabel>
          <Select value={courseInfo.isActive || ""} onChange={(e) => onChange("isActive", e.target.value)} label="האם פעיל">
            <MenuItem value={"Yes"}>כן</MenuItem>
            <MenuItem value={"No"}>לא</MenuItem>
          </Select>
        </FormControl>
      </AdminCoursesPopup>
      <div className="mb-10 fs-25">
        <Button color="primary" variant="contained" onClick={() => props.setEditMode(!props.editMode)}>
          החלף הוספת קורס
        </Button>
        {props.editMode && (
          <div className="flex justify-center items-center">
            <div className="flex">
              <TextField
                style={{ marginBottom: "20px", width: "350px" }}
                label="שם קורס חדש"
                value={courseInfo.title || ""}
                onChange={(e) => onChange("title", e.target.value)}
              />
              <FormControl variant="standard" style={{ width: "150px", marginRight: "10px" }}>
                <InputLabel>האם פעיל</InputLabel>
                <Select value={courseInfo.isActive || "Yes"} onChange={(e) => onChange("isActive", e.target.value)} label="האם פעיל">
                  <MenuItem value={"Yes"}>כן</MenuItem>
                  <MenuItem value={"No"}>לא</MenuItem>
                </Select>
              </FormControl>
            </div>
            <Button onClick={addCourse}>
              <AddBoxIcon />
            </Button>
          </div>
        )}
      </div>
      <div className="flex flex-direction-column items-center width70 nice-scroller-episodes">
        {props.courses.map((course, index) => {
          return (
            <div key={index} className="flex mt-20 width80 justify-between items-center">
              <div className="mt-10 ml-10">
                <Button color="primary" variant="contained" onClick={() => openEditPopup(course)}>
                  לערוך
                </Button>
              </div>
              <div className="fs-25 grow">{course.title}</div>
              <div className="">
                <Button color="primary" variant="contained" onClick={() => toggleCourseEpisodes(course.title)}>
                  פרקים
                </Button>
              </div>
              <div className="mr-10">
                <Button color="secondary" variant="contained" onClick={() => handleDelete(course._id, index)}>
                  <DeleteIcon />
                </Button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );

  function toggleCourseEpisodes(title) {
    props.setCourseTitle(title);
    props.setEditMode(true);
    props.setValue(1);
  }

  async function handleUpdate() {
    try {
      const res = await adminService.updateCourse(courseInfo);
      if (res.success) {
        Swal.fire("הקורס עודכן בהצלחה", "", "success");
        const courseList = [...props.courses];
        courseList[courseList.findIndex((course) => course._id === courseInfo._id)] = courseInfo;
        props.setCourses(courseList);
        handleClosePopup();
      } else {
        Swal.fire("שגיאה בעדכון הקורס", "", "error");
      }
    } catch (err) {
      console.log(err);
    }
  }

  async function handleDelete(id, index) {
    try {
      const res = await adminService.getCourseVideos(id);
      if (res.courseVideos.length > 0) {
        Swal.fire("לא ניתן למחוק את הקורס הזה", "לקורס הזה יש סרטונים הקשורים אליו. נא למחוק תחילה את הפרקים", "error");
      } else {
        Swal.fire({
          title: "האם אתה בטוח שברצונך למחוק את הקורס?",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "כן",
          cancelButtonText: "לא",
          closeOnConfirm: false,
          closeOnCancel: false
        }).then(async (result) => {
          if (result.value === true) {
            const res2 = await adminService.deleteCourse(id);
            if (res2.success) {
              Swal.fire("הקורס נמחק בהצלחה", "", "success");
              const courseList = [...props.courses];
              courseList.splice(index, 1);
              props.setCourses(courseList);
            } else {
              Swal.fire("לא ניתן היה למחוק את הקורס", "", "error");
            }
          }
        });
      }
    } catch (err) {
      console.log(err);
    }
  }

  async function addCourse() {
    try {
      if (courseInfo.title === "") return;
      if (!courseInfo.isActive) courseInfo.isActive = "Yes";
      const res = await adminService.addCourse(courseInfo);
      if (res.success) {
        Swal.fire("הקורס נוסף בהצלחה", "", "success");
        props.setEditMode(false);
        const courseList = [...props.courses];
        courseInfo._id = res.course.id;
        courseList.push(courseInfo);
        props.setCourses(courseList);
        setCourseInfo({});
      } else Swal.fire("לא ניתן להוסיף קורס", "", "warning");
    } catch (err) {
      console.log(err);
    }
  }

  function onChange(type, value) {
    const oldData = { ...courseInfo };
    oldData[type] = value;
    setCourseInfo(oldData);
  }

  function openEditPopup(courseDetails) {
    setCourseInfo(courseDetails);
    setIsPopupOpen(true);
  }

  function handleClosePopup() {
    setIsPopupOpen(false);
    setCourseInfo({});
  }
};

export default AdminCourses;
